/** Create, Register User */
export const LOG_IN = 'LOG_IN';
export const SOCIAL_LOGIN = 'SOCIAL_LOGIN';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAIL = 'LOG_IN_FAIL';
export const CREATE_USER = 'CREATE_USER';
export const SUBSCRIBE = 'SUBSCRIBE';
export const SOCIAL_LOGIN_EMAIL_VERIFICATION = 'SOCIAL_LOGIN_EMAIL_VERIFICATION';

/** Log Out */
export const LOG_OUT = 'LOG_OUT';

/** Aaa */
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_CLEAR = 'RESET_PASSWORD_CLEAR';
export const NEW_PASSWORD = 'NEW_PASSWORD';
export const EMAIL_VERIFY = 'EMAIL_VERIFY';
export const PASSWORD_RECOVERY_EMAIL_VERIFY = 'PASSWORD_RECOVERY_EMAIL_VERIFY';

/** Change Password */
export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

/** UserInfo */
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
